export const PERIOD_OPTIONS = [
  { value: "once", label: "Sekali", shortLabel: "Sekali", description: "Biaya yang tidak berulang." },
  { value: "daily", label: "Harian", shortLabel: "Harian", description: "Kelompok biaya harian; dapat dijadwalkan otomatis." },
  { value: "weekly", label: "Mingguan", shortLabel: "Mingguan", description: "Kelompok biaya mingguan; dapat dijadwalkan otomatis." },
  { value: "monthly", label: "Bulanan", shortLabel: "Bulanan", description: "Kelompok tagihan bulanan; dapat dijadwalkan otomatis." },
  { value: "yearly", label: "Tahunan", shortLabel: "Tahunan", description: "Kelompok biaya tahunan; dapat dijadwalkan otomatis." },
];

export const PERIOD_LABELS = PERIOD_OPTIONS.reduce((labels, item) => ({ ...labels, [item.value]: item.label }), {});

export const STATUS_META = {
  paid: { label: "Tercatat", className: "bg-success-lt" },
  cancelled: { label: "Dibatalkan", className: "bg-danger-lt" },
};

export const localDateTime = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

export const formatDateTime = (value) => value
  ? new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(value))
  : "-";
